// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__DrHY6","list":"BalanceDue_list__lnAjo","listRow":"BalanceDue_listRow__3-8p-","total":"BalanceDue_total__3Ad5t"};